var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseFaq = function SvgCloseFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.176 18.908 18.853 1.231l-.707-.708L.47 18.201l.707.707ZM.469 1.231l17.677 17.677.707-.707L1.177.523l-.707.708Z",
    fill: "#0C6CF3"
  })));
};

export { SvgCloseFaq as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuMTc1ODIgMTguOTA4MkwxOC44NTM1IDEuMjMwNTFMMTguMTQ2NCAwLjUyMzRMMC40Njg3MTIgMTguMjAxMUwxLjE3NTgyIDE4LjkwODJaTTAuNDY4NzEyIDEuMjMwNTFMMTguMTQ2NCAxOC45MDgyTDE4Ljg1MzUgMTguMjAxMUwxLjE3NTgyIDAuNTIzNEwwLjQ2ODcxMiAxLjIzMDUxWiIgZmlsbD0iIzBDNkNGMyIvPgo8L3N2Zz4K";